import { HUNTER, TITAN, WARLOCK } from 'app/lib/destinyEnums';

export default {
  1907674137: WARLOCK,
  1907674138: HUNTER,
  1907674139: TITAN
};



// WEBPACK FOOTER //
// ./src/extraData/classOverrides.js